<!-- @if (shouldDisplay()) {
<mat-nav-list>
	<a mat-list-item routerLink="/sommerfest-registration">
		<img matListItemAvatar src="assets/img/ystm-sommerfest-2026-plakat-v2.png" alt="YSTM Sommerfest 2026">
		<span matListItemTitle>65 Jahre YSTM</span>
		<span matListItemLine>Sommerfest am 20.06.2026</span>
		<span matListItemLine><strong>Jetzt anmelden</strong> </span>
	</a>
</mat-nav-list>
}  -->
@if (shouldDisplay()) {
<mat-nav-list>
	<a mat-list-item routerLink="/ausbildung">
		<img matListItemAvatar src="assets/img/edu-02.jpg" alt="Anmeldung SBF See/Binnen">
		<span matListItemTitle>YSTM-Kurse SBF-See / SBF-Binnen 2027</span>
		<span matListItemLine>Segeln lernen</span>
		<span matListItemLine><strong>Jetzt anmelden</strong> </span>
	</a>
</mat-nav-list>
} 